import clsx from 'clsx';
import type { ComponentPropsWithoutRef, ForwardedRef } from 'react';
import { forwardRef } from 'react';
import type { ErrorOption } from 'react-hook-form';
import { Input } from '../Input';
import styles from './Textarea.module.scss';
type Props = {
  error?: ErrorOption;
  hideLabel?: boolean;
  textareaClassName?: string;
} & ComponentPropsWithoutRef<'textarea'>;
const TextareaWithoutRef = ({
  className,
  error,
  hideLabel,
  textareaClassName,
  ...props
}: Props, ref: ForwardedRef<HTMLTextAreaElement>) => {
  return <Input {...props as Record<string, unknown>} as='textarea' className={clsx(styles.wrapper, className)} error={error} inputClassName={clsx(styles.textarea, error && styles.error, hideLabel && styles.hideLabel, textareaClassName)} ref={ref} data-sentry-element="Input" data-sentry-component="TextareaWithoutRef" data-sentry-source-file="Textarea.tsx" />;
};
export const Textarea = forwardRef(TextareaWithoutRef);